/*
 *   File : create-group.js
 *   Author : https://evoqins.com
 *   Description : Create user group modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//Style
import style from "../../Style/Component/report.module.scss"

//Custom components
import { Icon } from '../Icon';
import { CustomSearchInput, CustomTextInput, FileSelector } from '../FormElements';
import { CustomRadio, EmptyScreen, Loader } from '../Others';
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';
import UploadedPreview from './uploaded-preview';
import { APIService, AWSService } from '../../Service';
import { useLocation } from 'react-router-dom';

const USER_SELECT_DATA = [
    {
        id: 1,
        label: "Select manually",
    },
    {
        id: 2,
        label: "Upload user file"
    }
];

const FILE_TYPES = ["XLSX", "CSV"];

const CreateUserGroup = (props) => {

    const { state } = useLocation();

    const [selected, setSelected] = useState(1);

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [createFlow, setCreateFlow] = useState(1);

    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [fileName, setFileName] = useState({});

    const [preview, setPreview] = useState(false);
    const [fileLoader, setFileLoader] = useState(false);

    const [searchValue, setSearchValue] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [selectedUsersError, setSelectedUsersError] = useState("");
    const [showSelected, setShowSelected] = useState(false);

    const [loader, setLoader] = useState(true);
    const [userList, setUserList] = useState([]);

    useEffect(() => {
        if (state != null) {
            if (state.group_name) {
                setName(state.group_name);
            }
        }
    }, [state]);

    useEffect(() => {
        if (props.groupType) {
            setSelected(props.groupType);
        }
    }, [props.groupType]);

    useEffect(() => {
        if (props.confirmStatus === true) {
            _handleCloseModal();
        }
    }, [props.confirmStatus]);

    useEffect(() => {
        if (props.selectedUsers) {
            let updated_users = props.selectedUsers.map(data => ({
                name: data.username || data.customer_name,
                id: data.customer_id
            }))
            setSelectedUsers(updated_users);
            setShowSelected(true);
        }
    }, [props.selectedUsers]);

    useEffect(() => {
        if (preview === true) {
            const modal = new Modal(document.getElementById("uploaded-preview-modal"));
            modal.show();
        }
    }, [preview]);

    useEffect(() => {
        if (props.type === 2) {
            _userList();
        }
    }, [searchValue, props.type]);

    useEffect(() => {
        setNameError("");
    }, [name]);

    useEffect(() => {
        setFileError("");
    }, [file]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("create-group-modal-close");
        button.click();
        props.handleClose();
    };

    // handle select 
    const _handleSelect = (id) => {
        setSelected(id);
    };

    // handle select users 
    const _handleSelectUser = (users) => {
        const selectedUser = {
            id: users.customer_id,
            name: users.name
        };

        setSelectedUsers(prevUsers =>
            prevUsers.find(item => item.id === selectedUser.id)
                ? prevUsers.filter(item => item.id !== selectedUser.id)
                : [...prevUsers, selectedUser]
        );


        // setSelectedUsers(prevUsers =>
        //     prevUsers.find(item => item === users)
        //         ? prevUsers.filter(item => item !== users)
        //         : [...prevUsers, users]
        // );
    };

    const _handleRemoveSelectedUser = (user) => {
        setSelectedUsers(prev =>
            prev.filter(item => item.id !== user.id)
        );
    };

    // handle continue 
    const _handleContinue = () => {

        if (props.type !== 2) {
            if (name.trim().length === 0) {
                setNameError("Please provide group name");
                return;
            }
        }

        if (selected === 1) {
            props.handleContinue(name, selectedUsers);
            // _handleCloseModal();
        } else {
            setCreateFlow(2);
        }
    };

    // handle upload 
    const _handleUpload = () => {

        if (file === null) {
            setFileError("Please upload file");
            return;
        }

        setCreateFlow(3);
    };

    // handle change
    const _handleChange = (file) => {

        if (file.size > 1024 * 1024 * 10) {
            setFileError("File size exceeds the maximum limit of 10 MB");
            return;
        }

        _getPresignedUrl(file);
    };

    // handle clear file
    const _handleClear = () => {
        setFile(null);
    };

    // handle success 
    const _handleSuccess = () => {
        if (props.type === 2) {
            _addUsers();
        } else {
            _createGroup();
        }
    };

    // handle preview 
    const _handlePreview = () => {
        setPreview(true);
    };

    // Get - presigned url
    async function _getPresignedUrl(file) {

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        setFileLoader(true);
        setFileName(data)

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setFile(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setFileLoader(false);
    };


    // API - Create user group
    const _createGroup = () => {
        let is_post = true;
        let url = 'user/add-user-group';
        let request = {
            "type": 2,
            "file": file,
            "name": name
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                _handleCloseModal();
                props.handleSuccess();

                // toast.dismiss();
                // toast.success(response.message, { type: "success" });
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };

    // API - Add user to group
    const _addUsers = () => {
        let is_post = true;
        // let url = 'send-email/add-users';
        let url = 'user/add-user-group';
        let request = {
            "group_id": props.group_id,
            "type": 2,
            "file": file
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                _handleCloseModal();
                props.handleSuccess(response.message);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };

    // handle submit selected 
    const _handleSubmit = () => {
        setSearchValue("");
        setShowSelected(true);
    };

    // API -  user listing
    const _userList = () => {

        let is_post = true;
        let url = 'user/list';
        let request = {
            "query": searchValue,
            "page_num": 1,
            "page_size": 20,
            "investment_status": null,
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setUserList(response.data.data);
            } else {
                setUserList([]);
            }
            setLoader(false);
        });
    };


    return (
        <>
            <div className="modal fade"
                id="create-group-modal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true">

                <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 e-view-temp-modal`}>
                    <span id='create-group-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                    <div className={`${searchValue.length > 0 ? "overflow-visible" : ""} modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark`}>
                        {createFlow === 1 ?
                            <>
                                {/* modal header */}
                                <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                                    <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                        Create User Group
                                    </h6>
                                    <Icon icon='close'
                                        size="1.125rem"
                                        className="d-flex cursor-pointer"
                                        onClick={_handleCloseModal} />
                                </div>

                                {/* Modal body */}
                                <div className={`${searchValue.length > 0 ? "overflow-visible" : ""} modal-body pt-2 pb-3 padding-32px-lr`}>
                                    {props.type !== 2 &&
                                        <div className='pb-3'>
                                            <CustomTextInput label="Group name"
                                                placeholder="Enter Group name"
                                                type="text"
                                                autoFocus={true}
                                                required={true}
                                                value={name}
                                                error={nameError}
                                                className="w-100 "
                                                inputType={2}
                                                handleChange={(e) => setName(e)} />
                                        </div>
                                    }

                                    {props.groupType !== 2 &&
                                        <div>
                                            <CustomRadio label="Choose how you want to add users"
                                                required={true}
                                                data={USER_SELECT_DATA}
                                                selected={selected}
                                                className="d-flex align-items-center gap-3"
                                                handleSelect={_handleSelect} />
                                        </div>
                                    }

                                    {props.type === 2 && selected == 1 &&
                                        <div className='pt-3'>
                                            <div className='position-relative'>
                                                <CustomSearchInput placeholder="Search with customer ID or name"
                                                    type="text"
                                                    value={searchValue}
                                                    className="w-100"
                                                    clearIcon='top-14px right-38px'
                                                    onClear={() => setSearchValue("")}
                                                    handleChange={(e) => setSearchValue(e)} />

                                                {selectedUsersError &&
                                                    <p className={`position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                                                        {selectedUsersError}
                                                    </p>
                                                }

                                                <div className='pt-2'>
                                                    {showSelected === true &&
                                                        <div className='d-flex align-items-center gap-2 flex-wrap'>
                                                            {selectedUsers.map((users, key) => (
                                                                <div key={key} className='e-bg-lavender-blue d-flex align-items-center gap-1 px-2 py-1 border-radius-8'>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        {users.name}
                                                                    </p>
                                                                    <Icon icon="close"
                                                                        size={12}
                                                                        className="d-flex cursor-pointer"
                                                                        onClick={() => _handleRemoveSelectedUser(users)} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                </div>

                                                {searchValue.length > 0 &&
                                                    <div className={`${style.e_user_wrapper} e-bg-white border-radius-8 p-3 d-flex flex-column gap-2 position-absolute w-100 top-48px z-3 `}>
                                                        <div className='d-flex justify-content-end'>
                                                            <TextButton name="Clear all"
                                                                onClick={() => setSelectedUsers([])} />
                                                        </div>
                                                        {loader ?
                                                            <Loader className="py-5"
                                                                width={60}
                                                                height={60} />
                                                            :
                                                            <>
                                                                {userList.length !== 0 ?
                                                                    <>
                                                                        <div className={`${style.e_lists} d-flex flex-column gap-2 overscroll-behavior-none `}>
                                                                            {userList.map((user, key) => {
                                                                                const isSelected = selectedUsers.some(
                                                                                    selected => selected.id === user.customer_id
                                                                                );

                                                                                return (
                                                                                    <div key={key} className='d-flex gap-2  align-items-start cursor-pointer'
                                                                                        onClick={() => _handleSelectUser(user)}>
                                                                                        <Icon icon={isSelected ? "checkbox-active" : "checkbox-inactive"}
                                                                                            size={16}
                                                                                            className='cursor-pointer d-flex margin-2px-top' />
                                                                                        <div>
                                                                                            <p className='mb-1 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-16px'>
                                                                                                {user.name}
                                                                                            </p>
                                                                                            <p className='mb-0 e-text-davys-grey e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                                                {user.rayi_customer_id}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })}

                                                                        </div>
                                                                        <PrimaryButton name="Confirm"
                                                                            paddingBlock="padding-10px-all"
                                                                            onClick={_handleSubmit} />
                                                                    </>
                                                                    :
                                                                    <EmptyScreen width={48}
                                                                        height={48}
                                                                        padding="py-5 my-0"
                                                                        fontSize="e-font-14 line-height-20px"
                                                                        image={require('../../Assets/Image/NotFound/no-data.png')}
                                                                        description='No data found'
                                                                    />
                                                                }
                                                            </>}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>

                                {/* Modal footer */}
                                <div className='modal-footer pt-2 padding-32px-lr padding-32px-bottom border-0 gap-4'>
                                    <SecondaryButton name='Cancel'
                                        paddingBlock='padding-16px-tb padding-54px-lr'
                                        onClick={_handleCloseModal} />
                                    <PrimaryButton name='Continue'
                                        paddingBlock='padding-16px-tb padding-60px-lr'
                                        loader={props.loader}
                                        className={props.loader ? "w-175px" : ""}
                                        onClick={_handleContinue} />
                                </div>
                            </>
                            :

                            // Upload User File
                            createFlow === 2 ?
                                <>
                                    {/* modal header */}
                                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                            Upload User File
                                        </h6>
                                        <Icon icon='close'
                                            size="1.125rem"
                                            className="d-flex cursor-pointer"
                                            onClick={_handleCloseModal} />
                                    </div>

                                    {/* Modal body */}
                                    <div className='modal-body pt-2 pb-0 padding-32px-lr'>
                                        <div className='position-relative'>
                                            <FileSelector
                                                title='Upload file'
                                                downloadTitle='Download sample file'
                                                required={true}
                                                primeDataSize='Maximum file size: 10 MB'
                                                primeData='File supported: .CSV, .XLSX'
                                                type={1}
                                                error={fileError}
                                                value={file}
                                                fileDetails={fileName}
                                                fileType={FILE_TYPES}
                                                maxSize={1024 * 1024 * 10}
                                                loader={fileLoader}
                                                handleChange={_handleChange}
                                                handleClose={_handleClear} />

                                            <a href='https://rayi-dev.s3.amazonaws.com/public/admin/master/sample_user_group.csv' download className='mb-0 text-decoration-none e-text-blue-violet e-primary-font e-font-14 e-font-weight-600 line-height-16px cursor-pointer position-absolute top-0 end-0'>
                                                Download sample
                                            </a>
                                        </div>
                                    </div>

                                    {/* Modal footer */}
                                    <div className='modal-footer pt-1 padding-32px-lr padding-32px-bottom border-0 gap-4'>
                                        <SecondaryButton name='Cancel'
                                            paddingBlock='padding-16px-tb padding-54px-lr'
                                            onClick={() => setCreateFlow(1)} />
                                        <PrimaryButton name='Upload'
                                            paddingBlock='padding-16px-tb padding-64px-lr'
                                            onClick={_handleUpload} />
                                    </div>
                                </>
                                :
                                createFlow === 3 ?
                                    <>
                                        {/* modal header */}
                                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-2">
                                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                                Success!
                                            </h6>
                                            <Icon icon='close'
                                                size="1.125rem"
                                                className="d-flex cursor-pointer"
                                                onClick={_handleCloseModal} />
                                        </div>

                                        {/* Modal body */}
                                        <div className='modal-body pt-2 pb-3 padding-32px-lr'>
                                            <p className='mb-2 pb-1 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                                File <span className='e-font-weight-600'>{fileName.file}</span> uploaded successfully.
                                            </p>

                                            <TextButton name="Preview uploaded file"
                                                onClick={_handlePreview} />
                                        </div>

                                        {/* Modal footer */}
                                        <div className='modal-footer pt-2 padding-32px-lr padding-32px-bottom border-0 gap-4'>
                                            <SecondaryButton name='Cancel'
                                                paddingBlock='padding-16px-tb padding-76px-lr'
                                                onClick={() => setCreateFlow(2)} />
                                            <PrimaryButton name='Continue to add to group'
                                                paddingBlock='padding-16px-tb px-3'
                                                onClick={_handleSuccess} />
                                        </div>
                                    </>
                                    :
                                    null
                        }
                    </div>
                </div>
            </div>

            {preview === true &&
                <UploadedPreview file={file}
                    handleClose={() => {
                        setTimeout(() => {
                            setPreview(false);
                        }, 200);
                    }} />
            }
        </>
    )
}

export default CreateUserGroup;
